import { FC } from 'react'
import { DefaultOptions, QueryClient, QueryClientProvider } from 'react-query'

const defaultOptions: Partial<DefaultOptions> = {
  queries: {
    refetchOnWindowFocus: false,
    retry: 0,
  },
}

const config = { defaultOptions }
const queryClient = new QueryClient(config)

const QueryProvider: FC = ({ children }) => <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>

export { QueryProvider }
